import { Component, signal } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslocoPipe } from '@jsverse/transloco';
import { ButtonComponent, IconComponent } from '@zero/shared/ui-web-design-system';
import { commonRoutes } from 'constants/web-app-constants';
import { OnboardingContainerComponent } from '../../components/onboarding-container/onboarding-container.component';

@Component({
  imports: [OnboardingContainerComponent, ButtonComponent, TranslocoPipe, RouterLink, IconComponent],
  templateUrl: './in-progress.component.html',
  styleUrls: ['./in-progress.component.scss'],
})
export class InProgressComponent {
  public readonly depot = commonRoutes.postlogin.member_home;
  public readonly savingsPlan = commonRoutes.postlogin.onboarding.savingsPlan.favoriteSuggestions;
  public readonly investmentStrategy = commonRoutes.postlogin.onboarding.investmentStrategy.choice;

  public readonly toggledMoreInformationItems = signal([]);

  public toggleMoreInformation = (type: string) => {
    this.toggledMoreInformationItems.update((prev) =>
      this.toggledMoreInformationItems().includes(type) ? prev.filter((item) => item !== type) : [...prev, type],
    );
  };
}
